import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { getPaymentDetail } from "store/services/Store/List";
import { useSelector } from "react-redux";
import Checkout from "./Checkout";
import { Elements } from "@stripe/react-stripe-js";

const Payment = () => {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const { activeList, listOrder } = useSelector((store) => store.storeLists);
  const [placeOrderData, setPlaceOrderData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getPaymentDetail(
          user.accessToken,
          user.data.id,
          selectedStore.id,
          activeList.list_id
        );
        if (result.success) {
          setStripePromise(
            loadStripe(process.env.REACT_APP_STRIPE_PUBLISHIABLE_KEY)
          );
          setClientSecret(result.data.data.client_secret);
          const totalAmount = parseFloat(result.data.data.discountedPrice);
          setPlaceOrderData({
            paymentIntentId: result.data.data.stripe_intent_id,
            amount: totalAmount,
            orderPreference: listOrder?.preference,
            discountPercentage: result.data.data.discountPercentage,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [
    activeList.list_id,
    listOrder?.preference,
    selectedStore.id,
    user.accessToken,
    user.data.id,
  ]);

  return (
    <div>
      {stripePromise && clientSecret && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <Checkout placeOrderData={placeOrderData} />
        </Elements>
      )}
    </div>
  );
};

export default Payment;
